import { Component, EventEmitter, Output } from "@angular/core";

import { BaseComponent, StorageKeys, StorageService, UserService } from "@mypxplat/xplat/core";
import { AppService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "myp-add-edit-skill",
  templateUrl: "add-edit-skill.component.html",
  standalone: false,
})
export class AddEditSkillComponent extends BaseComponent {
  public loading: boolean = true;
  @Output() skillAdded: EventEmitter<any> = new EventEmitter();
  public skills: Array<any>;
  public mySkills: Array<any>;
  public skillTypeMap: any = {};
  public skillTypes: Array<string> = [];

  constructor(
    public userService: UserService,
    public activeModal: NgbActiveModal,
    public communityService: WebCommunityService,
    public storage: StorageService,
    public appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.communityService.getAvailableSkills().subscribe((skillsResult) => {
      this.communityService.getUserSkills().subscribe((mySkillsResult) => {
        if (mySkillsResult && mySkillsResult.length) {
          mySkillsResult.forEach((item) => {
            skillsResult.forEach((skill, i, theArray) => {
              if (skill.id == item.skill_id) {
                // Merge user-skill data onto the base skill record.
                // This preserves fields that exist only on the skills table (e.g. iterable_mapping).
                theArray[i] = { ...skill, ...item, selected: true };
              }
            });
          });
          this.skills = skillsResult;
        } else {
          this.skills = skillsResult;
        }
        this.skillTypes = [];
        this.skills.forEach((skill) => {
          if (!skill.skill_id) skill.skill_id = skill.id;
          if (!this.skillTypeMap[skill.type]) {
            this.skillTypeMap[skill.type] = {
              collapsed: false,
              skills: [],
            };
            this.skillTypes.push(skill.type);
          }
          this.skillTypeMap[skill.type].skills.push(skill);
        });
        this.loading = false;
      });
    });
  }

  submit() {
    this.loading = true;
    let selectedSkills = [...this.skills.filter((item) => item.selected === true)];
    let iterableSkills = [...this.skills.filter((item) => !!item.iterable_mapping)];
    let args = [];
    let string_ids = [];
    selectedSkills.forEach((item) => {
      let obj = {
        user_id: this.user.id,
        skill_id: item.skill_id,
        hourly_rate: item.hourly_rate ? item.hourly_rate : null,
        notes: item.notes ? item.notes : null,
        is_service: item.is_service ? item.is_service : null,
      };
      args.push(obj);
      string_ids.push(item.string_id);
    });
    this.storage.removeItem(StorageKeys.USER_SKILLS);
    this.communityService.addUserSkills(args, string_ids).subscribe(() => {
      let skillsToMapToIterable = selectedSkills.filter((item) => !!item.iterable_mapping);
      let interestsMap = {};
      iterableSkills.forEach((item) => {
        interestsMap[item.iterable_mapping] = false;
      });
      skillsToMapToIterable.forEach((item) => {
        interestsMap[item.iterable_mapping] = item.selected ? true : false;
      });

      if (skillsToMapToIterable.length) {
        this.userService.saveIterableSettings({ interests: interestsMap }).subscribe(() => {
          this.userService.getUserDetails(false).subscribe(() => {
            this.loading = false;
            this.activeModal.close();
            this.skillAdded.next(true);
          });
        });
      } else {
        this.loading = false;
        this.activeModal.close();
        this.skillAdded.next(true);
      }
    });
  }
}
